// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2RIGL","header":"MessagesList_header__1IB3R","chat":"MessagesList_chat__2ASW9"};